import React, { Component } from 'react';

import InputWrapper from '../../../../components/Common/InputWrapper';
import NowInput from '../../../../components/Common/NowInput';
import { trans } from '../../../../localization/index';
import GroupWrapper from '../../../../components/Common/GroupWrapper';
import { COMMON_CONST } from '../../../../constants/constants';
import NowSelect from '../../../../components/Common/NowSelect';
import { EnumWalletServiceType, genEnumToOption } from '../../../../constants/enum';

class WalletBasicInfo extends Component {
  walletServiceTypeOptions = genEnumToOption(EnumWalletServiceType);
  render() {
    const {
      ownerName,
      ownerPhone,
      ownerEmail,
      idCardNumber,
      address,
      required,
      isSubmit,
      handleChangeInput,
      maskServiceTypes = this.walletServiceTypeOptions[0],
    } = this.props;
    const isRequired = isSubmit && required;
    return (
      <React.Fragment>
        <InputWrapper
          label={trans('merchant_wallet_add_full_name')}
          required={required}
        >
          <NowInput
            value={ownerName}
            onChange={evt => handleChangeInput({ ownerName: evt.target.value })}
            name="ownerName"
            required={isRequired}
            placeholder={trans('merchant_wallet_add_full_name_holder')}
          />
        </InputWrapper>
        <GroupWrapper>
          <InputWrapper
            width="33.3%"
            label={trans('merchant_wallet_add_phone')}
            required={required}
          >
            <NowInput
              value={ownerPhone}
              onChange={evt =>
                handleChangeInput({ ownerPhone: evt.target.value })
              }
              name="ownerPhone"
              required={isRequired}
              phone
              isNumberFormat
              numberFormatProps={{
                format: COMMON_CONST.FormatPhoneNumber,
                mask: '',
              }}
              placeholder={trans('merchant_wallet_add_phone_holder')}
            />
          </InputWrapper>
          <InputWrapper
            width="33.3%"
            label={trans('merchant_wallet_add_email')}
            required={required}
          >
            <NowInput
              value={ownerEmail}
              onChange={evt =>
                handleChangeInput({ ownerEmail: evt.target.value.trim() })
              }
              name="ownerEmail"
              required={isRequired}
              email
              placeholder={trans('rebranding.merchant_wallet_add_email_holder')}
            />
          </InputWrapper>
          <InputWrapper
            width="33.3%"
            label={trans('merchant_wallet_add_id_number')}
            required={required}
          >
            <NowInput
              value={idCardNumber}
              onChange={evt =>
                handleChangeInput({ idCardNumber: evt.target.value.trim() })
              }
              name="idCardNumber"
              required={isRequired}
              isNumberFormat
              numberFormatProps={{
                format: '################',
                mask: '',
              }}
              placeholder={trans('merchant_wallet_add_id_number_holder')}
            />
          </InputWrapper>
        </GroupWrapper>
        <InputWrapper
          label={trans('merchant_wallet_add_address')}
          required={required}
        >
          <NowInput
            value={address}
            onChange={evt => handleChangeInput({ address: evt.target.value })}
            name="address"
            required={isRequired}
            placeholder={trans('merchant_wallet_add_address_holder')}
          />
        </InputWrapper>
        <InputWrapper
          label={trans('mwl_add_choose_type_payment')}
        >
          <NowSelect
            value={maskServiceTypes}
            options={this.walletServiceTypeOptions}
            isClearable={false}
            onChange={evt =>
              handleChangeInput({ maskServiceTypes: evt })
            }
            placeholder={trans('mwl_add_choose_type_payment_holder')}
          />
        </InputWrapper>
      </React.Fragment>
    );
  }
}

export default WalletBasicInfo;



// WEBPACK FOOTER //
// ./foody/src/pages/MerchantWallet/WalletManagement/components/WalletBasicInfo.jsx